// extracted by mini-css-extract-plugin
module.exports = {"purchaseComplete":"VerifiedPassword_purchaseComplete__gdLSM","stars":"VerifiedPassword_stars__3Bsx5","returnToVideo":"VerifiedPassword_returnToVideo__1lO5Y"};